import { reportSalesByZoneWholesalerTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SALES_BY_ZONE_WHOLESALER_FILTERS,
  RESTORE_INITIAL
} = reportSalesByZoneWholesalerTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSalesByZoneWholesalerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SALES_BY_ZONE_WHOLESALER_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
